import React, { ReactNode } from 'react'
import { ColorType, Flex, Text } from '@clear/design-system'

export type FeatureCardProps = {
  icon: ReactNode
  description: any
  descriptionColor?: ColorType
  borderWidth?: string
  borderStyle?: string
  borderColor?: string
  borderRadius?: string
  fontWeight?: number
}

export const FeatureCard = ({
  icon,
  description,
  borderWidth,
  borderStyle,
  borderColor,
  borderRadius,
  fontWeight = 700,
}: FeatureCardProps) => {
  return (
    <Flex
      borderWidth={borderWidth}
      borderStyle={borderStyle}
      borderColor={borderColor}
      borderRadius={borderRadius}
      flexDirection="column"
      justifyContent="center"
      alignItems="center"
      width={['90%', '30%']}
      maxWidth={['90%', '30%']}
      padding={5}
    >
      <Flex width="60px" height="60px" mb={5}>
        {icon}
      </Flex>
      <Text
        width="100%"
        as="h1"
        fontWeight={fontWeight}
        fontSize={[1, 3]}
        textAlign="center"
      >
        {description}
      </Text>
    </Flex>
  )
}
